import React from 'react';
import { BoxImage, CTAButton, TrustLine } from './CTAButton';
export function Hero() {
  return <header className="bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-76" data-mp="ejd33x29xuuc">
      <h1 className="font-heading text-[1.3rem] font-extrabold uppercase leading-[1.08] text-white sm:text-[2.3rem]" data-id="element-77" data-mp="9kjvumdkz02m">
        The Complete Visual Study System for{' '}
        <span className="text-gold" data-id="element-78" data-mp="4jm5vnmbx1qk">Radiology Students</span>
      </h1>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-[1.35] text-white/85 sm:text-[0.92rem]" data-id="element-79" data-mp="1286262e70it6">
        Stop jumping between textbooks, lecture notes and scattered images every
        time you need to understand radiology. Use organized visual references,
        annotated imaging examples and comparison tools to understand anatomy,
        recognize patterns and study imaging more clearly.
      </p>
      <p className="mt-1 font-body text-[0.74rem] font-extrabold uppercase leading-tight tracking-wide text-gold sm:text-sm" data-id="element-80" data-mp="3d2tqbf4z2uh6">
        See. Compare. Recognize with confidence.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[320px]" data-id="element-81" data-mp="3j925dog4jqvj" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-82" data-mp="3o7vl7nivvtyv">
        <CTAButton label="🩻 Yes! I want the complete system" data-id="element-83" data-mp="3o5j2v997rhla" />
        <p className="mt-1.5 font-body text-[0.66rem] font-extrabold uppercase tracking-[0.12em] text-white sm:text-xs" data-id="element-84" data-mp="399jmzcfv4d5l">
          Get Radiology Visual Atlas™ today
        </p>
        <TrustLine className="mt-1 !text-white/75" data-id="element-85" data-mp="30hhsdush5r38" />
      </div>
    </header>;
}